import { Button, ButtonMode, Modal, ModalWidth } from '@creditsights/styleguide-web';
import React from 'react';
import { EXTERNAL_ROUTES } from '../../../../Base.constants';
import { useGlobalModalContext } from '../../../../components/GlobalModal';
import { navigateToAnotherMfe } from '../../../../utils/navigationUtils';

const AddIssuersModal = (): React.ReactElement => {
  const { closeModal } = useGlobalModalContext();
  const navigateToCompaniesList = () => {
    navigateToAnotherMfe(EXTERNAL_ROUTES.companyList);
  };

  const renderFooter = () => (
    <>
      <Button dataTestId="add-issuers-cancel-button" mode={ButtonMode.SECONDARY} onClick={closeModal}>
        Cancel
      </Button>
      <Button onClick={navigateToCompaniesList} dataTestId="add-issuers-confirm-button" mode={ButtonMode.PRIMARY}>
        Go to Companies
      </Button>
    </>
  );

  return (
    <Modal width={ModalWidth.Small} headerTitle="Add an Issuer" onClose={closeModal} open footer={renderFooter()}>
      <p>You can easily add one or more issuers to the watchlist on the Companies page.</p>
    </Modal>
  );
};

export default AddIssuersModal;
